module.exports = __webpack_public_path__ + "img/wheel-of-dharma.aa0410c3.png";